import {Trans} from '@lingui/macro';
import {ellipsis} from 'polished';
import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {buildTeammateDisplayName} from '../../../../../helpers/modelHelpers';
import {TeammateModel} from '../../../../../models/api/teammateModel';
import {TeammateAvatar} from '../../../../common/avatars/teammateAvatar';

/*
 * Props.
 */

interface CellDraftSeedsProps {
  isSelected?: boolean;
  authors: ReadonlyArray<TeammateModel>;
}

/*
 * Style.
 */

const StyledAuthorDiv = styled.div`
  grid-area: bottom-left;
`;

const StyledContentDiv = styled.div`
  grid-area: bottom-line;
  display: flex;
  min-width: 0;
`;

interface CellDraftSeedsStyleProps {
  $isSelected?: boolean;
}
const StyledPrecogDiv = styled.div<CellDraftSeedsStyleProps>`
  display: flex;
  height: 20px;
  line-height: 20px;

  padding: 0 8px 0 6px;
  align-items: center;

  border-radius: 4px;
  background-color: ${(p) => (p.$isSelected ? p.theme.alphas.white30 : p.theme.greys.shade30)};
`;

const StyledContentAuthorDiv = styled.div<CellDraftSeedsStyleProps>`
  padding: 3px 0;

  color: ${(p) => (p.$isSelected ? p.theme.greys.white : p.theme.greys.shade80)};
  font-size: ${fontSizes.small};
  font-weight: ${fontWeights.semibold};

  ${ellipsis()};
`;

const StyledReplyingDiv = styled.div<CellDraftSeedsStyleProps>`
  flex-shrink: 0;
  padding: 3px 0;
  margin-right: 8px;

  color: ${(p) => (p.$isSelected ? p.theme.greys.white : p.theme.greys.shade70)};
  font-size: ${fontSizes.small};
`;

/*
 * Component.
 */

export const CellDraftSeeds: FC<CellDraftSeedsProps> = (props) => (
  <>
    <StyledAuthorDiv>{renderAvatar(props)}</StyledAuthorDiv>
    <StyledContentDiv>
      <StyledPrecogDiv $isSelected={props.isSelected}>
        <StyledContentAuthorDiv $isSelected={props.isSelected}>
          {renderTeammateName(props)}
        </StyledContentAuthorDiv>
        <StyledReplyingDiv $isSelected={props.isSelected}>
          &nbsp;<Trans id="cell-draft-seed-text">started a draft</Trans>
        </StyledReplyingDiv>
      </StyledPrecogDiv>
    </StyledContentDiv>
  </>
);

function renderTeammateName({authors}: CellDraftSeedsProps) {
  if (authors.length === 1) {
    return buildTeammateDisplayName(authors[0]);
  }

  return <Trans id="cell-draft-seed-count">{authors.length} teammates</Trans>;
}

function renderAvatar({authors, isSelected}: CellDraftSeedsProps) {
  const firstTeammate = authors[0];

  return <TeammateAvatar size={VisualSizesEnum.SMALL} teammate={firstTeammate} isSelected={isSelected} />;
}
